import React, { useContext, useState, useRef, useEffect } from 'react';
import { Row, Col, Stack, Badge } from 'react-bootstrap';
import { useLocation, useNavigate } from 'react-router-dom';
import 'assets/styles/common.scss';
import { LocaleContext } from 'routes/Router';
import { FormattedMessage, useIntl } from 'react-intl';
import MuiBreadcrumbs from 'components/common/MuiBreadcrumbs';
import { providerAdminSpecialists, superAdminProvider } from 'routes/AppUrls';
import ReusableTabs from 'components/common/Tabs';
import ProfileIcon from 'assets/images/navbar/profileIcon.png';
import SwitchInput from 'components/common/Input/SwitchInput';
import callIcon from 'assets/images/Dashboard/call.png';
import mailIcon from 'assets/images/Dashboard/mail.png';
import trash from 'assets/images/Dashboard/trash.png';
import rightArrow from 'assets/images/Dashboard/arrow-right.png';
import visaCardIcon from 'assets/images/provider/visa.png';
import PhotoImage from 'assets/images/provider/image4.png';
import Provider from 'assets/images/sidebar/ProviderColor.png';
import Avtar from 'assets/images/Dashboard/avtar.png';
import HouseIcon from 'assets/images/provider/HouseLine.png';
import StarIcon from '@mui/icons-material/Star';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import ScrollableTabs from 'components/common/SrollableTabs';
import ServiceList from 'Pages/SuperAdmin/Categories/ServiceList';
import MiniCalendar from 'Pages/SuperAdmin/MiniCalendar';
import { useDispatch, useSelector } from 'react-redux';
import { getAllProviderInformationDetailsCallAPI } from 'store/SuperAdmin/getAllProviderInformation/action';
import moment from 'moment';
import {
  basicDetailsCallApi,
  BASIC_DETAILS,
  SELECTED_TAB,
} from 'store/SuperAdmin/basicDetails/action';
import { getBasicProviderInformationCallAPI } from 'store/SuperAdmin/basicProviderInformation/action';
import {
  ShimmerBox,
  ShimmerCircle,
  ShimmerImage,
} from 'components/common/Shimmer';

const SalonDetails = () => {
  const navigate = useNavigate();
  const intl = useIntl();
  const { state } = useLocation();
  const dispatch = useDispatch();
  const { locale } = useContext(LocaleContext);
  const [tab, setTab] = useState(1);

  const specialistImageFileInputRef = useRef();
  const [specialistImageFile, setSpecialistImageFile] = useState(null);
  const [checked, setChecked] = useState(false);

  const getselectedTab = useSelector(
    (state) => state?.basicDetailsReducer?.selectedTab
  );
  const [selectedTab, setSelectedTab] = useState(getselectedTab);
  const [scrollTabData, setScrollTabData] = useState(null);
  const providerAllInformation = useSelector(
    (state) => state?.getAllProviderInformationDetailsReducer?.data?.data
  );
  const providerAllInformationLoading = useSelector(
    (state) => state?.getAllProviderInformationDetailsReducer?.loading
  );
  const basicProviderInformation = useSelector(
    (state) => state?.getBasicProviderInforrmationReducer?.data?.data
  );
  const basicProviderInformationLoading = useSelector(
    (state) => state?.getBasicProviderInforrmationReducer?.loading
  );

  useEffect(() => {
    AllProviderInformationApi();
    getBasicProviderDetails();
  }, []);

  useEffect(() => {
    const selectedCategory =
      providerAllInformation?.length > 0 && providerAllInformation[selectedTab];
    setScrollTabData(selectedCategory);
    dispatch(basicDetailsCallApi(BASIC_DETAILS, selectedCategory));
    dispatch(basicDetailsCallApi(SELECTED_TAB, selectedTab));
  }, [selectedTab, providerAllInformation]);

  const tabData = [
    { label: intl.formatMessage({ id: 'About' }) },
    { label: intl.formatMessage({ id: 'Services' }) },
    { label: intl.formatMessage({ id: 'Schedule' }) },
    { label: intl.formatMessage({ id: 'Specialists' }) },
    { label: intl.formatMessage({ id: 'Appointment History' }) },
    { label: intl.formatMessage({ id: 'Reviews' }) },
  ];

  const [breadcrumbsList, setBreadcrumbsList] = useState([
    {
      title:
        state?.specialists === 'ProviderAdmin' ? (
          <FormattedMessage id="Specialists" />
        ) : (
          <FormattedMessage id="Providers" />
        ),
      Link:
        state?.specialists === 'ProviderAdmin'
          ? providerAdminSpecialists(locale)
          : superAdminProvider(locale),
      isDisbale: false,
    },
    {
      title:
        state?.specialists === 'ProviderAdmin' ? (
          <FormattedMessage id="Specialist’s Details" />
        ) : (
          <FormattedMessage id="Provider Details" />
        ),
      Link: '',
      isDisbale: true,
    },
  ]);

  const handleTabChange = (val) => {
    setTab(val);
    switch (val) {
      case 1:
        AllProviderInformationApi('about');
        break;
      case 2:
        AllProviderInformationApi('services');
        break;
      case 3:
        break;
      case 4:
        AllProviderInformationApi('specialist');
        break;
      case 5:
        AllProviderInformationApi('appointment_history');
        break;
      case 6:
        AllProviderInformationApi('reviews');
        break;
    }
  };

  const getBasicProviderDetails = () => {
    dispatch(
      getBasicProviderInformationCallAPI(
        {},
        {
          id: state?.data?.id,
          navigate: navigate,
        }
      )
    );
  };

  const AllProviderInformationApi = (type = 'about') => {
    dispatch(
      getAllProviderInformationDetailsCallAPI(type, {
        id: state?.data?.id,
        navigate: navigate,
      })
    );
  };

  const handleScrollTabChange = (newValue) => {
    setSelectedTab(newValue);
  };

  const handleSpecialistImageFileChange = (e) => {
    const file = e.target.files[0];
    setSpecialistImageFile(URL.createObjectURL(file));
    if (file) {
      let Data = new FormData();
      Data.append('profile_image', file);
    }
  };

  const handleSpecialistImageUpload = () => {
    specialistImageFileInputRef.current.click();
  };

  const handleSwitchChange = (event) => {
    setChecked(!checked);
  };

  const ImageList = (images, maxVisible) => {
    const visibleImages = images.slice(0, maxVisible);
    const remainingCount = images.length - maxVisible;

    return (
      <div className="flex flex-wrap mt-3 gap-3 p-0">
        {visibleImages.map((image, index) => (
          <div className="image-item relative" key={index}>
            <img
              src={image?.image}
              alt={`Image ${index + 1}`}
              style={{ height: '124px', width: '124px' }}
            />
            {index === maxVisible - 1 && remainingCount > 0 && (
              <div className="overlay">
                <span>+{remainingCount}</span>
              </div>
            )}
          </div>
        ))}
      </div>
    );
  };

  const statusLegend = [
    {
      name: 'missed',
      text: 'Missed',
    },
    {
      name: 'completed',
      text: 'Completed',
    },
    {
      name: 'upcoming',
      text: 'Upcoming',
    },
    {
      name: 'cancelled',
      text: 'Cancelled',
    },
  ];

  const getStatusLegendColor = (status) => {
    switch (status) {
      case 'missed':
        return '#FFA500';
      case 'completed':
        return '#28A745';
      case 'upcoming':
        return '#007BFF';
      case 'cancelled':
        return '#DC3545';
    }
  };

  return (
    <Row className="bc-F2F3F6 m-0 p-0">
      <Col
        className={
          locale === 'en'
            ? 'commonEnContainer lg:ml-left'
            : 'commonArContainer lg:mr-right'
        }
      >
        <MuiBreadcrumbs size="14" list={breadcrumbsList} />
        <Row className="bc-FFFFFF m-0 p-16 mt-3">
          <input
            ref={specialistImageFileInputRef}
            type="file"
            accept=".png, .jpg, .jpeg"
            disabled={false}
            style={{ display: 'none' }}
            onChange={handleSpecialistImageFileChange}
          />

          {basicProviderInformationLoading ? (
            <div className="mt-4 flex justify-between items-center">
              <Stack direction="horizontal" gap={4} className="items-center">
                <ShimmerCircle size="88px" />
                <div>
                  <ShimmerBox width="200px" height="24px" />
                  <ShimmerBox width="150px" height="20px" className="mt-2" />
                </div>
              </Stack>
              <div>
                <ShimmerBox width="100px" height="16px" />
                <ShimmerBox width="200px" height="20px" className="mt-1" />
              </div>
            </div>
          ) : (
            <div className="mt-4 flex justify-between items-center">
              <Stack direction="horizontal" gap={4} className="items-center">
                <div className="AvtarImageIcon">
                  {basicProviderInformation?.profile_photo && (
                    <img
                      src={
                        basicProviderInformation?.profile_photo !== ''
                          ? basicProviderInformation?.profile_photo?.file_url
                          : specialistImageFile
                      }
                      alt={'icon'}
                      style={{
                        height: '88px',
                        width: '88px',
                        borderRadius: '50%',
                      }}
                    />
                  )}
                  <img
                    src={ProfileIcon}
                    alt="icon"
                    style={{ height: '32px', width: '32px' }}
                    className="profileIcon"
                    onClick={handleSpecialistImageUpload}
                  />
                </div>
                <div>
                  <p className="p-0 m-0 fs-18 fc-292D32 fw-400 ff-Akkurat_Bold">
                    {basicProviderInformation?.name?.name_en}
                  </p>
                </div>
              </Stack>

              <div>
                <p className="p-0 m-0 fs-14 fc-A4AAB2 fw-400 ff-Akkurat">
                  Location
                </p>
                <p className="p-0 m-0 fs-16 fc-292D32 fw-400 ff-Akkurat">
                  {basicProviderInformation?.address}
                </p>
              </div>
            </div>
          )}

          {/* <div className="">
              <SwitchInput
                label={<FormattedMessage id="Test User" />}
                checked={checked}
                onChange={(e) => handleSwitchChange(e)}
                color="secondary"
              />
            </div> */}

          {basicProviderInformationLoading ? (
            <>
              <Col xs={12} md={3} className="mt-3">
                <ShimmerBox width="120px" height="16px" />
                <ShimmerBox width="150px" height="20px" className="mt-1" />
              </Col>

              <Col xs={12} md={3} className="mt-3">
                <ShimmerBox width="100px" height="16px" />
                <ShimmerBox width="150px" height="20px" className="mt-1" />
              </Col>

              <Col xs={12} md={3} className="mt-3">
                <ShimmerBox width="80px" height="16px" />
                <ShimmerBox width="150px" height="20px" className="mt-1" />
              </Col>

              <Col xs={12} md={2} className="mt-3 text-center">
                <ShimmerBox width="100px" height="16px" />
                <ShimmerBox width="120px" height="20px" className="mt-1" />
              </Col>
            </>
          ) : (
            <>
              <Col xs={12} md={3} className="mt-3">
                <Stack direction="horizontal" gap={2} className="items-center">
                  <p className="p-0 m-0 fs-14 fc-A4AAB2 fw-400 ff-Akkurat">
                    Account Manager
                  </p>
                </Stack>
                <p className="p-0 m-0 fs-16 fc-292D32 fw-400 ff-Akkurat mt-1">
                  {basicProviderInformation?.branch_manager_name}
                </p>
              </Col>

              <Col xs={12} md={3} className="mt-3">
                <Stack direction="horizontal" gap={2} className="items-center">
                  <img
                    src={callIcon}
                    alt="icon"
                    style={{ height: '20px', width: '20px' }}
                  />
                  <p className="p-0 m-0 fs-14 fc-A4AAB2 fw-400 ff-Akkurat">
                    Phone number
                  </p>
                </Stack>
                <p className="p-0 m-0 fs-16 fc-292D32 fw-400 ff-Akkurat mt-1">
                  {basicProviderInformation?.contact_number}
                </p>
              </Col>

              <Col xs={12} md={3} className="mt-3">
                <Stack direction="horizontal" gap={2} className="items-center">
                  <img
                    src={mailIcon}
                    alt="icon"
                    style={{ height: '20px', width: '20px' }}
                  />
                  <p className="p-0 m-0 fs-14 fc-A4AAB2 fw-400 ff-Akkurat">
                    Email
                  </p>
                </Stack>
                <p className="p-0 m-0 fs-16 fc-292D32 fw-400 ff-Akkurat mt-1">
                  {basicProviderInformation?.email}
                </p>
              </Col>

              <Col xs={12} md={2} className="mt-3 text-center">
                <p className="p-0 m-0 fs-14 fc-A4AAB2 fw-400 ff-Akkurat">
                  Active since:
                </p>
                <p className="p-0 m-0 fs-16 fc-292D32 fw-400 ff-Akkurat mt-1">
                  {basicProviderInformation?.joining_on
                    ? moment(basicProviderInformation?.joining_on).format(
                        'DD MMM YYYY'
                      )
                    : ''}
                </p>
              </Col>
            </>
          )}
        </Row>

        <Row className="mt-3 pt-1">
          <Col xs={12} md={10}>
            <ReusableTabs
              tabs={tabData}
              defaultTab={tab}
              currentTab={(val) => handleTabChange(val)}
            />
          </Col>
        </Row>

        {tab === 1 && (
          <>
            {providerAllInformationLoading ? (
              <Row className="bc-FFFFFF m-0 p-16 mt-3">
                <ShimmerBox width="150px" height="24px" />
                <ShimmerBox width="100%" height="16px" className="mt-3" />
                <ShimmerBox width="90%" height="16px" className="mt-2" />
                <ShimmerBox width="80%" height="16px" className="mt-2" />
                <div className="flex flex-wrap mt-3 gap-3 p-0">
                  {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((item) => (
                    <ShimmerImage key={item} />
                  ))}
                </div>
              </Row>
            ) : (
              <Row className="bc-FFFFFF m-0 p-16 mt-3">
                <h5 className="p-0 m-0 fs-18 fc-292D32 fw-400 ff-Akkurat_Bold">
                  {'Information'}
                </h5>
                <p className="p-0 m-0 fs-16 fc-A2A2A2 fw-400 ff-Akkurat mt-3">
                  {providerAllInformation?.about_information_en}
                </p>
              </Row>
            )}

            {/* <Row className="bc-FFFFFF m-0 p-16 mt-3">
              <h5 className="p-0 m-0 fs-18 fc-292D32 fw-400 ff-Akkurat_Bold">
                {'Ambience'}
              </h5>
              <div className="flex flex-wrap mt-2 gap-3  p-0">
                {providerAllInformation?.ambience?.length > 0 &&
                  providerAllInformation?.ambience.map((k, i) => (
                    <Badge
                      pill
                      className={'d-flex items-center text-center ambiencePill'}
                    >
                      {k}
                    </Badge>
                  ))}
              </div>
            </Row> */}

            {/* <Row className="bc-FFFFFF m-0 p-16 mt-3">
              <h5 className="p-0 m-0 fs-18 fc-292D32 fw-400 ff-Akkurat_Bold">
                {'Payment Methods'}
              </h5>
              <div className="flex flex-wrap mt-3 gap-3  p-0">
                {providerAllInformation?.paymentmethods?.length > 0 &&
                  providerAllInformation.paymentmethods.map((key, index) => {
                    if (key?.name === 'Visa') {
                      return (
                        <img
                          src={visaCardIcon}
                          alt="icon"
                          style={{ height: '40px', width: '73px' }}
                        />
                      );
                    } else {
                      return (
                        <img
                          src={visaCardIcon}
                          alt="icon"
                          style={{ height: '40px', width: '73px' }}
                        />
                      );
                    }
                  })}
              </div>
            </Row> */}

            {!providerAllInformationLoading && (
              <Row className="bc-FFFFFF m-0 p-16 mt-3">
                <h5 className="p-0 m-0 fs-18 fc-292D32 fw-400 ff-Akkurat_Bold">
                  {'Photos'}
                </h5>

                {providerAllInformation?.bussiness_images?.length > 0 && (
                  <>
                    <div className="p-0">
                      {ImageList(providerAllInformation?.bussiness_images, 10)}
                    </div>
                  </>
                )}
              </Row>
            )}
          </>
        )}

        {tab === 2 && (
          <>
            {providerAllInformationLoading ? (
              <Row className="bc-FFFFFF m-0 p-16 mt-3">
                <Row className="m-0 p-0">
                  <Col md={12}>
                    <div className="flex gap-4 mb-3">
                      {[1, 2, 3, 4, 5].map((item) => (
                        <ShimmerBox key={item} width="120px" height="60px" />
                      ))}
                    </div>
                  </Col>
                </Row>
                <Row className="m-0 p-0 mt-2">
                  {[1, 2, 3, 4].map((item) => (
                    <Col key={item} md={6} className="mb-3">
                      <ShimmerBox width="100%" height="200px" />
                    </Col>
                  ))}
                </Row>
              </Row>
            ) : (
              <Row className="bc-FFFFFF m-0 p-16 mt-3">
                {providerAllInformation?.length > 0 && (
                  <>
                    <Row className="m-0 p-0">
                      <Col md={12}>
                        <ScrollableTabs
                          tabs={providerAllInformation.map((items, index) => ({
                            label: items?.category_name,
                            icon: items?.category_icon,
                          }))}
                          onTabChange={handleScrollTabChange}
                          initialTab={0}
                        />
                      </Col>
                    </Row>

                    {providerAllInformation.map(
                      (items, index) =>
                        scrollTabData?.category_id === items?.category_id && (
                          <>
                            {items?.products_list?.length > 0 && (
                              <Row className="m-0 p-0 mt-2">
                                <ServiceList
                                  services={items?.products_list}
                                  // onEdit={(data) => handleEditService(data)}
                                  // onDelete={(data) => handleDeleteService(data)}
                                  // onDeleteSubService={(data) =>
                                  //   handleDeleteSubService(data)
                                  // }
                                  // onAddService={(data) => handleAddService(data)}
                                />
                              </Row>
                            )}
                          </>
                        )
                    )}
                  </>
                )}
              </Row>
            )}
          </>
        )}

        {tab === 3 && (
          <>
            {providerAllInformationLoading ? (
              <Row className="m-0 p-0 mt-3">
                <Col md={12}>
                  <ShimmerBox width="100%" height="500px" />
                </Col>
              </Row>
            ) : (
              <Row className="m-0 p-0 mt-3">
                <MiniCalendar />
              </Row>
            )}
          </>
        )}

        {tab === 4 && (
          <>
            {providerAllInformationLoading ? (
              <>
                <Row className="mt-3 listHeader m-0 p-0 flex items-center">
                  {[1, 2, 3, 4, 5, 6].map((item) => (
                    <Col key={item} lg={2} md={6} sm={12}>
                      <ShimmerBox width="100px" height="20px" />
                    </Col>
                  ))}
                </Row>
                <Row className="bc-FFFFFF m-0 p-0">
                  {[1, 2, 3, 4, 5].map((item) => (
                    <Row
                      key={item}
                      className="m-0 p-2 flex items-center listAppointment"
                    >
                      <Col lg={2} md={6} sm={12}>
                        <ShimmerBox width="150px" height="20px" />
                      </Col>
                      <Col lg={2} md={6} sm={12}>
                        <ShimmerBox width="100px" height="20px" />
                        <ShimmerBox
                          width="100px"
                          height="20px"
                          className="mt-2"
                        />
                      </Col>
                      <Col lg={3} md={6} sm={12}>
                        <ShimmerBox width="150px" height="20px" />
                        <ShimmerBox
                          width="150px"
                          height="20px"
                          className="mt-2"
                        />
                      </Col>
                      <Col lg={2} md={6} sm={12}>
                        <ShimmerBox width="100px" height="20px" />
                      </Col>
                      <Col lg={1} md={6} sm={12}>
                        <ShimmerBox width="50px" height="20px" />
                      </Col>
                      <Col lg={2} md={6} sm={12}>
                        <ShimmerBox width="100px" height="20px" />
                      </Col>
                    </Row>
                  ))}
                </Row>
              </>
            ) : (
              <>
                <Row className="mt-3 listHeader m-0 p-0 flex items-center">
                  <Col lg={2} md={6} sm={12}>
                    <p className="p-0 m-0 fs-14 fw-400 fc-292D32 ff-Akkurat_Bold">
                      <FormattedMessage id="Specialist" />
                    </p>
                  </Col>
                  <Col lg={2} md={6} sm={12}>
                    <p className="p-0 m-0 fs-14 fw-400 fc-292D32 ff-Akkurat_Bold">
                      <FormattedMessage id="Service Type" />
                    </p>
                  </Col>
                  <Col lg={3} md={6} sm={12}>
                    <p className="p-0 m-0 fs-14 fw-400 fc-292D32 ff-Akkurat_Bold">
                      <FormattedMessage id="Contact Info" />
                    </p>
                  </Col>
                  <Col lg={2} md={6} sm={12}>
                    <p className="p-0 m-0 fs-14 fw-400 fc-292D32 ff-Akkurat_Bold">
                      <FormattedMessage id="Joined On" />
                    </p>
                  </Col>
                  <Col lg={1} md={6} sm={12}>
                    <p className="p-0 m-0 fs-14 fw-400 fc-292D32 ff-Akkurat_Bold">
                      <FormattedMessage id="Status" />
                    </p>
                  </Col>
                  <Col lg={2} md={6} sm={12}>
                    <p className="p-0 m-0 fs-14 fw-400 fc-292D32 ff-Akkurat_Bold">
                      <FormattedMessage id="Actions" />
                    </p>
                  </Col>
                </Row>

                <Row className="bc-FFFFFF m-0 p-0">
                  {providerAllInformation?.length > 0 &&
                    providerAllInformation.map((key, index) => (
                      <Row className="m-0 p-0 flex items-center listAppointment">
                        <Col lg={2} md={6} sm={12}>
                          <p className="p-0 m-0 fs-14 fc-292D32 fw-400 ff-Akkurat_Bold">
                            {key?.name?.name_en}
                          </p>
                        </Col>

                        <Col lg={2} md={6} sm={12}>
                          <p className="p-0 m-0 fs-12 fw-400 fc-292D32 ff-Akkurat_Bold">
                            <Stack
                              direction="horizontal"
                              gap={2}
                              className="items-center "
                            >
                              <img
                                src={HouseIcon}
                                alt="icon"
                                style={{ height: '20px', width: '20px' }}
                              />
                              <p className="p-0 m-0 fs-12 fc-292D32 fw-400 ff-Akkurat">
                                {'At Home'}
                              </p>
                            </Stack>
                            <Stack
                              direction="horizontal"
                              gap={2}
                              className="items-center mt-2"
                            >
                              <img
                                src={Provider}
                                alt="icon"
                                style={{ height: '20px', width: '20px' }}
                              />
                              <p className="p-0 m-0 fs-12 fc-292D32 fw-400 ff-Akkurat">
                                {'In Salon'}
                              </p>
                            </Stack>
                          </p>
                        </Col>

                        <Col lg={3} md={6} sm={12}>
                          <p className="p-0 m-0 fs-12 fw-400 fc-292D32 ff-Akkurat_Bold">
                            <Stack
                              direction="horizontal"
                              gap={2}
                              className="items-center "
                            >
                              <img
                                src={mailIcon}
                                alt="icon"
                                style={{ height: '20px', width: '20px' }}
                              />
                              <p className="p-0 m-0 fs-12 fc-292D32 fw-400 ff-Akkurat">
                                {key?.email}
                              </p>
                            </Stack>
                            <Stack
                              direction="horizontal"
                              gap={2}
                              className="items-center mt-2"
                            >
                              <img
                                src={callIcon}
                                alt="icon"
                                style={{ height: '20px', width: '20px' }}
                              />
                              <p className="p-0 m-0 fs-12 fc-292D32 fw-400 ff-Akkurat">
                                {key?.contact_number}
                              </p>
                            </Stack>
                          </p>
                        </Col>

                        <Col lg={2} md={6} sm={12}>
                          <p className="p-0 m-0 fs-14 fw-400 fc-292D32 ff-Akkurat">
                            {key?.joining_on !== '' && key?.joining_on !== null
                              ? moment(key?.joining_on).format('DD MMM YYYY')
                              : ''}
                          </p>
                        </Col>

                        <Col lg={1} md={6} sm={12}>
                          <SwitchInput
                            label={true}
                            checked={key?.status}
                            onChange={(e) => handleSwitchChange(e)}
                            color="secondary"
                          />
                        </Col>

                        <Col lg={2} md={6} sm={12}>
                          <Stack
                            direction="horizontal"
                            gap={3}
                            className="items-center "
                          >
                            <img
                              src={trash}
                              alt="icon"
                              style={{ height: '24px', width: '24px' }}
                            />
                            <Stack
                              direction="horizontal"
                              gap={2}
                              className="items-center "
                            >
                              <p className="p-0 m-0 fs-14 fc-292D32 fw-400 ff-Akkurat_Bold underline underline-offset-4">
                                <FormattedMessage id="View Details" />
                              </p>
                              <img
                                src={rightArrow}
                                alt="icon"
                                style={{ height: '20px', width: '20px' }}
                              />
                            </Stack>
                          </Stack>
                        </Col>
                      </Row>
                    ))}
                </Row>
              </>
            )}
          </>
        )}

        {tab === 5 && (
          <>
            <Row className="m-0 p-0 mt-3 bg-[#ffffff] p-2">
              <p className="p-0 m-0 fs-14 fw-400 fc-292D32 ff-Akkurat_Bold">
                {'Appointment status legend'}
              </p>

              <div className="flex items-center flex-wrap gap-4 m-0 p-0 pb-3 mt-4">
                {statusLegend.map((item) => (
                  <div key={item?.name} className="flex items-center gap-2">
                    <div
                      className="w-3 h-3 rounded-full"
                      style={{
                        backgroundColor: getStatusLegendColor(item?.name),
                      }}
                    ></div>
                    <p className="p-0 m-0 fs-14 fw-400 fc-292D32 ff-Akkurat_Bold">
                      {item?.text}
                    </p>
                  </div>
                ))}
              </div>
            </Row>

            {providerAllInformationLoading ? (
              <>
                <Row className="mt-3 listHeader m-0 p-0 flex items-center">
                  {[1, 2, 3, 4, 5, 6].map((item) => (
                    <Col key={item} lg={2} md={6} sm={12}>
                      <ShimmerBox width="100px" height="20px" />
                    </Col>
                  ))}
                </Row>
                <Row className="bc-FFFFFF m-0 p-0">
                  {[1, 2, 3, 4, 5].map((item) => (
                    <Row
                      key={item}
                      className="m-0 p-2 flex items-center listAppointment"
                    >
                      <Col lg={1} md={6} sm={12}>
                        <ShimmerBox width="80px" height="20px" />
                      </Col>
                      <Col lg={2} md={6} sm={12}>
                        <div className="flex items-center gap-2">
                          <ShimmerCircle size="40px" />
                          <div>
                            <ShimmerBox width="120px" height="16px" />
                            <ShimmerBox
                              width="100px"
                              height="16px"
                              className="mt-1"
                            />
                          </div>
                        </div>
                      </Col>
                      <Col lg={3} md={6} sm={12}>
                        <div className="flex items-center gap-2">
                          <ShimmerCircle size="40px" />
                          <div>
                            <ShimmerBox width="120px" height="16px" />
                            <ShimmerBox
                              width="100px"
                              height="16px"
                              className="mt-1"
                            />
                          </div>
                        </div>
                      </Col>
                      <Col lg={3} md={6} sm={12}>
                        <ShimmerBox width="150px" height="20px" />
                        <ShimmerBox
                          width="200px"
                          height="16px"
                          className="mt-1"
                        />
                      </Col>
                      <Col lg={2} md={6} sm={12}>
                        <ShimmerBox width="100px" height="20px" />
                        <ShimmerBox
                          width="80px"
                          height="16px"
                          className="mt-1"
                        />
                      </Col>
                      <Col lg={1} md={6} sm={12}>
                        <ShimmerBox width="80px" height="20px" />
                      </Col>
                    </Row>
                  ))}
                </Row>
              </>
            ) : (
              <>
                <Row className="mt-3 listHeader m-0 p-0 flex items-center">
                  <Col lg={1} md={6} sm={12}>
                    <p className="p-0 m-0 fs-14 fw-400 fc-292D32 ff-Akkurat_Bold">
                      <FormattedMessage id="Booking ID" />
                    </p>
                  </Col>
                  <Col lg={2} md={6} sm={12}>
                    <p className="p-0 m-0 fs-14 fw-400 fc-292D32 ff-Akkurat_Bold">
                      <FormattedMessage id="Customer" />
                    </p>
                  </Col>
                  <Col lg={3} md={6} sm={12}>
                    <p className="p-0 m-0 fs-14 fw-400 fc-292D32 ff-Akkurat_Bold">
                      <FormattedMessage id="Specialist" />
                    </p>
                  </Col>
                  <Col lg={3} md={6} sm={12}>
                    <p className="p-0 m-0 fs-14 fw-400 fc-292D32 ff-Akkurat_Bold">
                      <FormattedMessage id="Service Location" />
                    </p>
                  </Col>
                  <Col lg={2} md={6} sm={12}>
                    <p className="p-0 m-0 fs-14 fw-400 fc-292D32 ff-Akkurat_Bold">
                      <FormattedMessage id="Date & Time" />
                    </p>
                  </Col>
                  <Col lg={1} md={6} sm={12}>
                    <p className="p-0 m-0 fs-14 fw-400 fc-292D32 ff-Akkurat_Bold">
                      <FormattedMessage id="Action" />
                    </p>
                  </Col>
                </Row>

                <Row className="bc-FFFFFF m-0 p-0">
                  {providerAllInformation?.length > 0 &&
                    providerAllInformation.map((key, index) => (
                      <Row className="m-0 p-2 flex items-center listAppointment">
                        <Row
                          className="m-0 p-0 flex items-center border-l-[8px]"
                          style={{
                            borderLeftColor: getStatusLegendColor(
                              key?.order_status
                            ),
                          }}
                        >
                          <Col lg={1} md={6} sm={12}>
                            <p className="p-0 m-0 fs-12 fw-400 fc-292D32 ff-Akkurat">
                              {key?.booking_id}
                            </p>
                          </Col>

                          <Col lg={2} md={6} sm={12}>
                            <Stack
                              direction="horizontal"
                              gap={2}
                              className="items-center"
                            >
                              <img
                                src={
                                  key?.customers_image
                                    ? key?.customers_image
                                    : Avtar
                                }
                                alt="icon"
                                style={{
                                  height: '40px',
                                  width: '40px',
                                  borderRadius: '100px',
                                }}
                              />
                              <div>
                                <p className="p-0 m-0 fs-12 fc-292D32 fw-400 ff-Akkurat_Bold">
                                  {key?.customers_data?.customers_name}
                                </p>
                                <p className="p-0 m-0 fs-12 fw-400 fc-292D32 ff-Akkurat">
                                  {key?.customers_data?.customers_id}
                                </p>
                              </div>
                            </Stack>
                          </Col>

                          <Col lg={3} md={6} sm={12}>
                            <Stack
                              direction="horizontal"
                              gap={2}
                              className="items-center"
                            >
                              <img
                                src={
                                  key?.provider_image
                                    ? key?.provider_image
                                    : Avtar
                                }
                                alt="icon"
                                style={{
                                  height: '40px',
                                  width: '40px',
                                  borderRadius: '100px',
                                }}
                              />
                              <div>
                                <p className="p-0 m-0 fs-12 fc-292D32 fw-400 ff-Akkurat_Bold">
                                  {locale === 'en'
                                    ? key?.provider_data?.name_en
                                    : key?.provider_data?.name_ar}
                                </p>
                                <p className="p-0 m-0 fs-12 fw-400 fc-292D32 ff-Akkurat">
                                  {key?.provider_data?.provider_id}
                                </p>
                              </div>
                            </Stack>
                          </Col>

                          <Col lg={3} md={6} sm={12}>
                            <Stack
                              direction="horizontal"
                              gap={2}
                              className="items-center"
                            >
                              <img
                                src={Provider}
                                alt="icon"
                                style={{ height: '24px', width: '24px' }}
                              />
                              <p className="p-0 m-0 fs-14 fc-292D32 fw-400 ff-Akkurat_Bold">
                                {key?.service_location}
                              </p>
                            </Stack>
                            <p className="p-0 m-0 fs-12 fc-292D32 fw-400 ff-Akkurat mt-1 truncate">
                              {key?.delivery_address}
                            </p>
                          </Col>

                          <Col lg={2} md={6} sm={12}>
                            <p className="p-0 m-0 fs-12 fw-400 fc-292D32 ff-Akkurat">
                              {key?.slot_date !== null &&
                              key?.slot_date !== undefined
                                ? moment(key?.slot_date).format('DD MMM YYYY')
                                : ''}
                            </p>
                            <p className="p-0 m-0 fs-12 fw-400 fc-292D32 ff-Akkurat">
                              {key?.slot_start_time !== null &&
                              key?.slot_start_time !== undefined
                                ? moment(key?.slot_start_time).format('h:mm A')
                                : ''}
                            </p>
                          </Col>

                          <Col lg={1} md={6} sm={12}>
                            <p className="p-0 m-0 fs-12 fw-400 fc-292D32 ff-Akkurat">
                              {key?.order_status !== null &&
                              key?.order_status !== undefined
                                ? key?.order_status
                                : ''}
                            </p>
                          </Col>
                        </Row>
                      </Row>
                    ))}
                </Row>
              </>
            )}
          </>
        )}

        {tab === 6 && (
          <>
            {providerAllInformationLoading ? (
              <Row className="bc-FFFFFF m-0 p-16 mt-3">
                <Col xs={12} md={12}>
                  <ShimmerBox width="150px" height="24px" />
                </Col>
                <Col xs={12} md={3} className="mt-3">
                  <ShimmerBox width="60px" height="32px" />
                  <div className="flex gap-1 mt-1">
                    {[1, 2, 3, 4, 5].map((item) => (
                      <ShimmerBox key={item} width="20px" height="20px" />
                    ))}
                  </div>
                </Col>
                <Col xs={12} md={7} className="">
                  {[1, 2, 3].map((item) => (
                    <Col
                      key={item}
                      xs={12}
                      md={12}
                      className="mt-3 border-b bColor-E3E3E3 pb-2"
                    >
                      <div className="flex items-center gap-3">
                        <ShimmerCircle size="88px" />
                        <div>
                          <ShimmerBox width="150px" height="20px" />
                          <ShimmerBox
                            width="120px"
                            height="16px"
                            className="mt-2"
                          />
                        </div>
                      </div>
                      <div className="flex items-center gap-3 mt-3">
                        <div className="flex gap-1">
                          {[1, 2, 3, 4, 5].map((star) => (
                            <ShimmerBox key={star} width="20px" height="20px" />
                          ))}
                        </div>
                        <ShimmerBox width="30px" height="20px" />
                      </div>
                      <ShimmerBox width="100%" height="16px" className="mt-2" />
                      <ShimmerBox width="90%" height="16px" className="mt-1" />
                    </Col>
                  ))}
                </Col>
              </Row>
            ) : (
              <Row className="bc-FFFFFF m-0 p-16 mt-3">
                <Col xs={12} md={12}>
                  <h5 className="p-0 m-0 fs-18 fw-400 fc-292D32 ff-Akkurat_Bold">
                    {'Reviews'}
                  </h5>
                </Col>

                <Col xs={12} md={3} className="mt-3">
                  <p className="p-0 m-0 fs-32 fw-400 fc-292D32 ff-Akkurat_Bold">
                    {providerAllInformation?.average_rating}
                  </p>
                  <Stack
                    direction="horizontal"
                    spacing={1}
                    className="mt-1 items-center"
                  >
                    {[1, 2, 3, 4, 5].map((star) => (
                      <div
                        key={star}
                        className={
                          star <= providerAllInformation?.average_rating
                            ? 'starfill'
                            : 'starUnfill'
                        }
                      >
                        {star <= providerAllInformation?.average_rating ? (
                          <StarIcon fontSize="medium" />
                        ) : (
                          <StarBorderIcon fontSize="medium" />
                        )}
                      </div>
                    ))}
                  </Stack>
                </Col>

                <Col xs={12} md={7} className="">
                  {providerAllInformation?.reviews?.map((value, index) => (
                    <Col
                      xs={12}
                      md={12}
                      className="mt-3 border-b bColor-E3E3E3 pb-2"
                    >
                      <Stack
                        direction="horizontal"
                        gap={3}
                        className="items-center"
                      >
                        <img
                          src={value?.given_by_user[0]?.user_image}
                          alt={'icon'}
                          style={{
                            height: '88px',
                            width: '88px',
                            borderRadius: '50%',
                          }}
                        />
                        <div>
                          <p className="p-0 m-0 fs-18 fc-292D32 fw-400 ff-Akkurat_Bold">
                            {value?.given_by_user[0]?.name}
                          </p>
                          <p className="p-0 m-0 mt-2 fs-14 fc-A2A2A2 fw-400 ff-Akkurat">
                            {moment(value?.created_at).format('Do MMMM, YYYY')}
                          </p>
                        </div>
                      </Stack>

                      <Stack
                        direction="horizontal"
                        gap={3}
                        className="mt-3 items-center"
                      >
                        <>
                          <div className="flex">
                            {[1, 2, 3, 4, 5].map((star) => (
                              <div
                                key={star}
                                className={
                                  star <= value?.rating
                                    ? 'starfill'
                                    : 'starUnfill'
                                }
                              >
                                {star <= value?.rating ? (
                                  <StarIcon fontSize="medium" />
                                ) : (
                                  <StarBorderIcon fontSize="medium" />
                                )}
                              </div>
                            ))}
                          </div>
                          <p className="p-0 m-0 fs-18 fc-292D32 fw-400 ff-Akkurat_Bold">
                            {value?.rating}
                          </p>
                        </>
                      </Stack>

                      <div className="mt-2">
                        <p className="p-0 m-0 fs-16 fc-A2A2A2 fw-400 ff-Akkurat">
                          {value?.review}
                        </p>
                      </div>
                    </Col>
                  ))}
                </Col>
              </Row>
            )}
          </>
        )}
      </Col>
    </Row>
  );
};

export default SalonDetails;
